import { MarkovGroup } from "server/models"
import { OrderType } from "client/utils"

export interface MarkovGroupProps {
    groupId: number
}

export type MarkovGroupValidation = { [key in keyof MarkovGroup]?: string}

export interface MarkovGroupList { [groupId: number]: MarkovGroup }
export interface MarkovGroupFilters {
    search?: string
}

export interface MarkovGroupState {
    groupList: MarkovGroupList
    groupIds: readonly number[]
    groupEdit: MarkovGroup

    sortColumn: keyof MarkovGroup
    sortOrder: OrderType
    filters: MarkovGroupFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_GROUP_LIST = "MARKOV_GROUP_LIST"
export const MARKOV_GROUP_IDS = "MARKOV_GROUP_IDS"
export const MARKOV_GROUP_EDIT = "MARKOV_GROUP_EDIT"

export const MARKOV_GROUP_SORT = "MARKOV_GROUP_SORT"
export const MARKOV_GROUP_FILTERS = "MARKOV_GROUP_FILTERS"

export const MARKOV_GROUP_RELOAD_LIST = "MARKOV_GROUP_RELOAD_LIST"
export const MARKOV_GROUP_RELOAD_EDIT = "MARKOV_GROUP_RELOAD_EDIT"
